var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPriceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9991_1004)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "#27272C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.75 30C38.75 26.1342 44.6265 23 51.875 23C59.1235 23 65 26.1342 65 30C65 33.8658 59.1235 37 51.875 37C44.6265 37 38.75 33.8658 38.75 30ZM51.875 40.5C50.0777 40.5 48.3733 40.2987 46.8158 39.9488C44.4375 38.1655 40.5403 37 36.125 37C28.8765 37 23 40.1343 23 44C23 47.8657 28.8765 51 36.125 51C43.3735 51 49.25 47.8657 49.25 44C49.25 43.9492 49.2377 43.9002 49.236 43.8495H49.25V47.5C49.25 51.3657 43.3735 54.5 36.125 54.5C28.8765 54.5 23 51.3657 23 47.5V51C23 54.8657 28.8765 58 36.125 58C43.3735 58 49.25 54.8657 49.25 51V54.5C49.25 58.3657 43.3735 61.5 36.125 61.5C28.8765 61.5 23 58.3657 23 54.5V58C23 61.8657 28.8765 65 36.125 65C43.3735 65 49.25 61.8657 49.25 58V57.86C50.0987 57.951 50.9755 58 51.875 58C59.1235 58 65 54.8657 65 51V47.5C65 51.2083 59.589 54.2357 52.75 54.4772V50.9773C59.589 50.7358 65 47.71 65 44V40.5C65 44.2083 59.589 47.2358 52.75 47.4773V43.9773C59.589 43.7358 65 40.71 65 37V33.5C65 37.3658 59.1235 40.5 51.875 40.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9991_1004"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 88,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceIcon);
export default __webpack_public_path__ + "static/media/price-icon.beaf8b0e90fc470c1b29cb290feac1de.svg";
export { ForwardRef as ReactComponent };